import { forwardRef, useRef, useState } from 'react'
import { FullscreenImageModal } from './components/FullscreenImageModal'
import { ZoomImageContainer } from '@app/components/common/imageMagnifier/components/ZoomImageContainer'
import { Box } from '@mui/material'

type ImageMagnifierProps = {
  src?: string
  alt?: string
  className?: string
  tabIndex?: number
  children?: string | JSX.Element | JSX.Element[]
}

export const ImageMagnifier = forwardRef<any, ImageMagnifierProps>((props, ref) => {
  const [openFullImage, setOpenFullImage] = useState(false)
  const fullscreenButtonRef = useRef<HTMLButtonElement>(null)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const handleClose = () => {
    setOpenFullImage(false)
    requestAnimationFrame(() => {
      // Focus the zoomable image area (StyledBox) which triggers :focus-within,
      // making the ZoomPanel visible. Then focus the fullscreen button.
      const zoomArea = wrapperRef.current?.firstElementChild as HTMLElement
      zoomArea?.focus()
      requestAnimationFrame(() => {
        fullscreenButtonRef.current?.focus()
      })
    })
  }

  return (
    <Box ref={wrapperRef} onClick={e => e.stopPropagation()}>
      <ZoomImageContainer
        isFullscreen={false}
        setOpenFullImage={setOpenFullImage}
        fullscreenButtonRef={fullscreenButtonRef}
        {...props}
        ref={ref}
      />

      <FullscreenImageModal opened={openFullImage} onClose={handleClose} disableRestoreFocus>
        <Box p={2}>
          <ZoomImageContainer isFullscreen={true} setOpenFullImage={handleClose} {...props} ref={ref} />
        </Box>
      </FullscreenImageModal>
    </Box>
  )
})
